import request from './common/request'

import { MERCHANT_FINANCE_ACCOUNT_STATEMENT_SUMMARY_URL } from './urls'

async function detail () {
  return request({
    url: MERCHANT_FINANCE_ACCOUNT_STATEMENT_SUMMARY_URL,
    method: 'GET'
  })
}

export default {
  detail
}



// WEBPACK FOOTER //
// ./src/api/merchant-finance-account-statement-summary.js